import { Injectable } from '@angular/core';
import { Ga4WrapperService, eventData } from '@am/ga4-wrapper';
import { EventItemParamsClass } from '@core/models/ga4/event_item_params.class';
import { SearchStateService } from './search-state.service';
import { DateService } from './date.service';
import { PriceService } from './price.service';
import { ItemParams } from '@core/models/ga4/item.class';
@Injectable()
export class Ga4Service {
  newEventParams: EventItemParamsClass;
  hotelName = '';

  constructor(
    private ga4Tracking: Ga4WrapperService,
    private searchService: SearchStateService,
    private dateService: DateService,
    private priceService: PriceService,
  ) {}

  view_item(recommended: any, country: any, city, rate: any, amenities: any, hotel: any, isPriorityProvider = false) {
    this.newEventParams = new EventItemParamsClass(this.searchService, this.dateService);
    const objectData = this.createEventData('view_item');
    objectData.eventParams = this.newEventParams.getData();
    this.loadCurencyAndValue(objectData, recommended, country, city, rate, amenities);
    if (isPriorityProvider) {
      objectData.eventParams.marketing_tag_type = 'priority_provider';
    }
    objectData.eventParams.items.push(new ItemParams(hotel, rate, this.priceService));
    this.ga4Tracking.callEvent(objectData);
  }

  add_to_cart(recommended: any, country: any, city: any, rate: any, amenities: any, isPriorityProvider = false) {
    const objectData = this.createEventData('add_to_cart');
    objectData.eventParams = this.newEventParams.getData();
    objectData.eventParams.element = 'Reservar';
    this.loadCurencyAndValue(objectData, recommended, country, city, rate, amenities);
    this.loadRateInfo(objectData, rate);
    if (isPriorityProvider) {
      objectData.eventParams.marketing_tag_type = 'priority_provider';
    }
    this.ga4Tracking.callEvent(objectData);
  }

  user_interaction(data: any) {
    const objectData = this.createEventData('user_interaction');
    const ga4TrakingData = {
      element: data.element,
      action: data.action === undefined ? 'click' : data.action,
      section: `PDP :: ${data.section}`.toLocaleLowerCase(),
      producto: 'disney',
    };
    objectData.eventParams = { ...ga4TrakingData };
    this.ga4Tracking.callEvent(objectData);
  }

  private createEventData(eventName): eventData {
    return {
      event: 'ga4.trackEvent',
      eventName,
      eventParams: {},
    };
  }

  private services(amenities: any): string {
    let strServicios = '';
    amenities.forEach((amenitie) => {
      strServicios += amenitie.description + ' // ';
    });
    return strServicios;
  }

  loadCurencyAndValue(
    objectData,
    recommended: any,
    country: any,
    city: any,
    rate: any,
    amenities: any,
  ) {
    objectData.eventParams.recomendado = recommended;
    objectData.eventParams.region = country !== undefined ? country.name : city.name;
    if (rate !== null) {
      objectData.eventParams.currency = (
        rate.price.currency.code as string
      ).toLocaleLowerCase();
      objectData.eventParams.value = this.priceService.getPrice(rate, 'TOTAL', true);
    }
    objectData.eventParams.servicios = this.services(amenities);
  }

  loadRateInfo(objectData, rate) {
    if (rate !== undefined) {
      objectData.eventParams.plan_de_comida = rate.price.currency.code;
      objectData.eventParams.value = this.priceService.getPrice(rate, 'TOTAL', true);
    }
  }
}
